// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__27wCf","col":"styles_col__31GZn"};